import {
    SET_USER,
    IS_LOADING,
    LOGGING_IN_ERROR,
    SAVED_USERNAME
} from '../actions/types';

const INITIAL_STATE = {
    user: [],
    orderProcessSteps: [],
    loadingPage: false,
    errorLoggingIn: false,
    savedUserName: '',
    loginErrorMessage: ''

};

export default (state = INITIAL_STATE, action) => {

    switch (action.type) {
        case SET_USER:

            //if (action.payload.realex_Enabled === true) {
            //    return { ...state, user: action.payload, orderProcessSteps: ['Place an Order', 'Order Summary', 'Payment', 'Order Confirmation'] };
            //}
            //else {
            //    return { ...state, user: action.payload, orderProcessSteps: ['Place an Order', 'Order Summary', 'Order Confirmation'] };
            //}

            if (action.payload.realex_Enabled === true) {
                return { ...state, user: action.payload, orderProcessSteps: ['Start', 'Summary', 'Payment', 'Confirmation'] };
            }
            else {
                return { ...state, user: action.payload, orderProcessSteps: ['Start', 'Summary', 'Confirmation'] };
            }

        //case GET_USER:
        //    return { ...state };


        case IS_LOADING:
            return { ...state, loadingPage: action.payload };

        case LOGGING_IN_ERROR:

            return { ...state, errorLoggingIn: action.payload.error, loginErrorMessage: action.payload.errorMessage };

        case SAVED_USERNAME:
            return { ...state, savedUserName: action.payload };

        default:
            return state;
    }

}